import { EventEmitter } from "eventemitter3";
import Logger from "./logger";

export default class UploadProgressService extends EventEmitter {
  constructor(options) {
    super();
    this._timer = null;
    this._tasks = new Map();
    this._uploaded = new Map();
    this._logger = new Logger({ debug: options.debug });
  }

  _start() {
    if (this._timer) return;
    this._timer = setInterval(() => this._calcSpeed(), 1000);
  }

  clean() {
    this._tasks.clear();
    this._uploaded.clear();
    if (!this._timer) return;
    clearInterval(this._timer);
    this._timer = null;
    this._logger.log("定时器已清除");
  }

  clear(tid) {
    this._uploaded.delete(tid);
    this._tasks.delete(tid);
    if (this._tasks.size === 0) {
      this.clean();
    }
  }

  execute(tid, bytes, total) {
    // uploaded bytes
    this.commit(tid, bytes, total);
    // speed test
    const task = this._tasks.get(tid);
    const time = new Date().getTime();
    const data = { bytes, time };
    if (task == null) {
      this._tasks.set(tid, [data]);
      this._calcSpeed();
    } else {
      const items = this._tasks.get(tid);
      items.push(data);
    }
    this._start();
  }

  commit(tid, bytes, total) {
    let uploaded = this._uploaded.get(tid) || 0;
    uploaded += bytes;
    this._uploaded.set(tid, uploaded);
    if (uploaded >= total) uploaded = total;
    this.emit("progress", { tid, uploaded, total });
  }

  _calcSpeed() {
    for (const [tid, items] of this._tasks) {
      const now = new Date().getTime();
      const start = now - 2000;
      const lastItems = items.filter((item) => item.time >= start);
      this._tasks.set(tid, lastItems);
      const bytes = lastItems.map((item) => item.bytes);
      let rate = bytes.reduce((a, b) => a + b, 0);
      rate = ~~(rate / 2);
      const commit = this._uploaded.get(tid);
      this.emit("speed", { tid, rate, commit });
    }
  }
}
